import { ISnScrollPosition } from './scroll.interfaces';

export function isScrollingDown(
  prevPos: ISnScrollPosition,
  currentPos: ISnScrollPosition,
): boolean {
  return prevPos.scrollTop < currentPos.scrollTop;
}

export function shouldTriggerEvents(
  prevPos: ISnScrollPosition,
  currentPos: ISnScrollPosition,
  threshold: number,
  thresholdUp: number,
): boolean {
  let remaining: number;
  let containerBreakpoint: number;

  const scrollingDown = isScrollingDown(prevPos, currentPos);
  const scrolledUntilNow = currentPos.scrollTop + currentPos.clientHeight;
  const scrollingRemain = currentPos.scrollHeight - scrolledUntilNow;

  if (scrollingDown) {
    remaining = scrollingRemain / currentPos.scrollHeight;
    containerBreakpoint = threshold / 100;
  } else {
    remaining = currentPos.scrollTop / (currentPos.scrollTop + scrollingRemain);
    containerBreakpoint = thresholdUp / 100;
  }

  return remaining <= containerBreakpoint;
}
